import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../../core/services/event.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { UtilityService } from '../../../../core/services/utility.service';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';

@Component({
  selector: 'app-reset-approval-modal',
  templateUrl: './reset-approval-modal.component.html',
  styleUrls: ['./reset-approval-modal.component.css'],
})
export class ResetApprovalModalComponent implements OnInit {
  @Input() receiptID: any;
  @Input() receiptItemID: any;
  constructor(
    private employeeService: EmployeeService,
    public activeModal: NgbActiveModal,
    private eventService: EventService
  ) {}

  ngOnInit(): void {}

  public onClick(isItem: boolean) {
    this.employeeService
      .submitItems(this.receiptID, '', null, isItem ? this.receiptItemID : null)
      .then((response: any) => {
        this.activeModal.close({ success: response.success, error: null });
      })
      .catch((error: any) => {
        this.activeModal.close({ success: false, error: error.error });
      });
  }

  public cancelClicked() {
    this.activeModal.close();
  }
}
